var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-family":"monospace"}},_vm._l((_vm.data),function(value,key){return _c('div',[_c('strong',[_vm._v(_vm._s(key))]),(typeof value == 'object')?[_c('div',{staticClass:"padding-left"},[_c('Json',{attrs:{"data":value}})],1)]:[_vm._v("\n\t\t\t"+_vm._s(value)+"\n\t\t")]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }